var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7931A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.00630876,-0.00301984)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197,124.2c-13.4,53.6-67.6,86.2-121.2,72.8C22.2,183.7-10.4,129.4,3,75.8C16.4,22.2,70.6-10.4,124.2,3 C177.7,16.4,210.3,70.6,197,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.1,85.8c2-13.3-8.1-20.5-22-25.2l4.5-18l-11-2.7l-4.4,17.5c-2.9-0.7-5.8-1.4-8.8-2.1l4.4-17.7l-11-2.7 l-4.5,18c-2.4-0.5-4.7-1.1-7-1.6l0-0.1l-15.1-3.8l-2.9,11.7c0,0,8.1,1.9,8,2c4.4,1.1,5.2,4,5.1,6.4L74.3,88 c0.3,0.1,0.7,0.2,1.1,0.4c-0.4-0.1-0.8-0.2-1.2-0.3l-7.2,28.8c-0.5,1.3-1.9,3.4-5,2.6c0.1,0.2-8-2-8-2L48.7,130l14.3,3.6 c2.7,0.7,5.3,1.4,7.8,2l-4.5,18.2l11,2.7l4.5-18c3,0.8,5.9,1.6,8.7,2.3l-4.5,18l11,2.7l4.5-18.2c18.7,3.5,32.8,2.1,38.7-14.8 c4.8-13.6-0.2-21.5-10.1-26.6C137.2,100.2,142.6,95.5,144.1,85.8z M119,120.9c-3.4,13.6-26.3,6.3-33.8,4.4l6-24.2 C98.7,103,122.6,106.7,119,120.9z M122.4,85.6c-3.1,12.4-22.2,6.1-28.4,4.6l5.5-21.9C105.7,69.8,125.6,72.6,122.4,85.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.14d3be9c4e5b12cb8de45da8482bf37c.svg";
export { ForwardRef as ReactComponent };